import { NextModalStyles } from '../../../../../modals/NextModal'

export const styles: NextModalStyles = {
  content: {
    backgroundColor: 'white',
    border: 'none',
    borderRadius: 0,
    bottom: '0',
    boxSizing: 'border-box',
    left: '0',
    padding: '12px 24px',
    pointerEvents: 'all',
    right: '0',
    top: 'auto',
    transitionDuration: '0.4s',
    transitionProperty: 'opacity, transform',
    transitionTimingFunction: 'ease',
  },
  overlay: {
    background: 'none',
    pointerEvents: 'none',
    zIndex: 100,
  },
}
